import React from 'react';
import { Link } from 'react-router-dom';
import { IMAGES, CLINIC } from '../data/content';

const WAIcon = () => <svg width="16" height="16" viewBox="0 0 32 32" fill="currentColor"><path d="M16 0C7.163 0 0 7.163 0 16c0 2.82.737 5.467 2.027 7.76L.069 31.076l7.52-1.972A15.94 15.94 0 0016 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm7.5 19.5c-.3.85-1.5 1.55-2.45 1.75-.65.14-1.5.25-4.35-.95-3.65-1.52-6-5.22-6.18-5.46-.17-.24-1.47-1.96-1.47-3.73s.93-2.64 1.26-2.97c.27-.28.72-.4 1.15-.4.14 0 .26 0 .38.01.33.01.49.03.71.55.3.69 1.03 2.47 1.12 2.65.09.18.18.42.05.66-.12.25-.22.36-.4.57-.18.2-.35.36-.53.58-.16.19-.35.4-.14.73.21.32.93 1.53 1.99 2.48 1.37 1.22 2.51 1.6 2.88 1.77.27.12.59.08.81-.14.27-.28.61-.75.95-1.22.24-.33.55-.38.87-.26.33.11 2.1.99 2.46 1.17.36.18.6.27.68.42.09.15.09.85-.21 1.67z"/></svg>;
const FBIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg>;
const IGIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5"/><path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>;
const YTIcon = () => <svg width="18" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M22.54 6.42a2.78 2.78 0 00-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 001.46 6.42 29 29 0 001 12a29 29 0 00.46 5.58 2.78 2.78 0 001.95 1.96C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 001.95-1.96A29 29 0 0023 12a29 29 0 00-.46-5.58z"/><polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="#0C0602"/></svg>;
const GoogleIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M21.35 11.1H12.18V13.83H18.69C18.36 17.64 15.19 19.27 12.19 19.27C8.36 19.27 5 16.25 5 12C5 7.9 8.2 4.73 12.2 4.73C15.29 4.73 17.1 6.7 17.1 6.7L19 4.72C19 4.72 16.56 2 12.1 2C6.42 2 2.03 6.8 2.03 12C2.03 17.05 6.16 22 12.25 22C17.6 22 21.5 18.33 21.5 12.91C21.5 11.76 21.35 11.1 21.35 11.1Z"/></svg>;

const col1 = [['/','Home'],['/about','About'],['/panchakarma','Panchakarma'],['/kerala-therapies','Kerala Therapies'],['/treatments','Treatments']];
const col2 = [['/gallery','Gallery'],['/blog','Blogs'],['/contact','Contact'],['/swarna-prashan','Swarna Prashan'],['/dosha-quiz','Dosha Quiz']];

export default function Footer() {
  return (
    <footer style={{ background: '#0C0602', borderTop: '1px solid rgba(255,255,255,0.05)', padding: '44px 40px 24px' }}>
      <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1.6fr 0.9fr 0.9fr 1.1fr 1.1fr', gap: '32px', marginBottom: '32px' }}>

          {/* Brand */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '14px' }}>
              <img src={IMAGES.logo} alt="Vaidyam" style={{ height: '28px', objectFit: 'contain' }} onError={e => e.target.style.display='none'} />
              <span style={{ fontFamily: 'Saman, Cormorant Garamond, serif', fontSize: '16px', color: '#F0E6D8', letterSpacing: '0.5px' }}>Vaidyam Ayurveda</span>
            </div>
            <p style={{ fontSize: '12px', color: 'rgba(240,230,216,0.28)', lineHeight: 1.85, maxWidth: '200px' }}>
              Bhopal's most trusted Kerala Ayurveda Panchakarma center since 2003.
            </p>
          </div>

          {/* Quick Links col 1 */}
          <div>
            <div style={{ fontSize: '9px', letterSpacing: '2px', color: '#C8941A', textTransform: 'uppercase', fontWeight: 600, marginBottom: '14px' }}>Quick Links</div>
            {col1.map(([path, label]) => (
              <Link key={path} to={path} style={{ display: 'block', fontSize: '12px', color: 'rgba(240,230,216,0.32)', marginBottom: '8px', transition: 'color 0.2s', textDecoration: 'none' }}
                onMouseEnter={e => e.target.style.color = '#F0E6D8'}
                onMouseLeave={e => e.target.style.color = 'rgba(240,230,216,0.32)'}
              >{label}</Link>
            ))}
          </div>

          {/* Quick Links col 2 */}
          <div>
            <div style={{ fontSize: '9px', letterSpacing: '2px', color: '#C8941A', textTransform: 'uppercase', fontWeight: 600, marginBottom: '14px' }}>&nbsp;</div>
            {col2.map(([path, label]) => (
              <Link key={path} to={path} style={{ display: 'block', fontSize: '12px', color: 'rgba(240,230,216,0.32)', marginBottom: '8px', transition: 'color 0.2s', textDecoration: 'none' }}
                onMouseEnter={e => e.target.style.color = '#F0E6D8'}
                onMouseLeave={e => e.target.style.color = 'rgba(240,230,216,0.32)'}
              >{label}</Link>
            ))}
          </div>

          {/* Address */}
          <div>
            <div style={{ fontSize: '9px', letterSpacing: '2px', color: '#C8941A', textTransform: 'uppercase', fontWeight: 600, marginBottom: '14px' }}>Address</div>
            <div style={{ fontSize: '12px', color: 'rgba(240,230,216,0.32)', lineHeight: 2 }}>
              <div style={{ color: 'rgba(240,230,216,0.5)', fontWeight: 500 }}>Vaidyam Kerala Ayurveda</div>
              <div style={{ color: 'rgba(240,230,216,0.5)' }}>Panchakarma Treatment Center</div>
              <div style={{ marginTop: '6px' }}>22, New MLA Colony</div>
              <div>Jawahar Chowk</div>
              <div>Near Unique College</div>
              <div>Bhopal — 462003</div>
            </div>
          </div>

          {/* Contact Us */}
          <div>
            <div style={{ fontSize: '9px', letterSpacing: '2px', color: '#C8941A', textTransform: 'uppercase', fontWeight: 600, marginBottom: '14px' }}>Contact Us</div>
            <div style={{ fontSize: '12px', color: 'rgba(240,230,216,0.32)', lineHeight: 2, marginBottom: '14px' }}>
              <div>0755-4224044</div>
              <div>+91 94257 06830</div>
            </div>
            <div style={{ fontSize: '9px', letterSpacing: '1.5px', color: 'rgba(240,230,216,0.2)', textTransform: 'uppercase', marginBottom: '10px' }}>Connect</div>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              {[
                { url: CLINIC.facebook, icon: <FBIcon /> },
                { url: CLINIC.instagram, icon: <IGIcon /> },
                { url: CLINIC.youtube, icon: <YTIcon /> },
                { url: `https://wa.me/${CLINIC.whatsapp}`, icon: <WAIcon /> },
                { url: CLINIC.gmaps, icon: <GoogleIcon /> },
              ].map((s, i) => (
                <a key={i} href={s.url} target="_blank" rel="noreferrer"
                  style={{ width: '30px', height: '30px', borderRadius: '3px', background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.06)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'rgba(240,230,216,0.3)', transition: 'all 0.2s', textDecoration: 'none' }}
                  onMouseEnter={e => { e.currentTarget.style.color = '#C8941A'; e.currentTarget.style.borderColor = 'rgba(200,148,26,0.3)'; }}
                  onMouseLeave={e => { e.currentTarget.style.color = 'rgba(240,230,216,0.3)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.06)'; }}
                >{s.icon}</a>
              ))}
            </div>
          </div>
        </div>

        <div style={{ borderTop: '1px solid rgba(255,255,255,0.04)', paddingTop: '18px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ fontSize: '11px', color: 'rgba(240,230,216,0.15)' }}>© 2026 Vaidyam Ayurveda · Bhopal</div>
          <div style={{ fontSize: '11px', color: 'rgba(200,148,26,0.3)' }}>Central Govt. Reimbursement Available</div>
        </div>
      </div>
      <style>{`@font-face { font-family: 'Saman'; src: url('/fonts/Saman.ttf') format('truetype'); }`}</style>
    </footer>
  );
}
